export const cleanupQuery = (query: string): string => {
  // Remove EXPLAIN and some other common options of EXPLAIN (doesn't cover all the cases)
  return query.replace(
    /^\s*EXPLAIN(\s+\([^)]*\)|\s+ANALYZE\s+VERBOSE|\s+ANALYZE|\s+VERBOSE)?\s*/i,
    "",
  );
};
